import { render, staticRenderFns } from "./ResumenCuota.vue?vue&type=template&id=1f4c4df6&scoped=true&"
import script from "./ResumenCuota.vue?vue&type=script&lang=js&"
export * from "./ResumenCuota.vue?vue&type=script&lang=js&"
import style0 from "./ResumenCuota.vue?vue&type=style&index=0&id=1f4c4df6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c4df6",
  null
  
)

export default component.exports